import type { PinOnImageResult } from '@core-api/presentation/types/response';
import { PinOnImage } from '@mentimeter/visualizations-react/visualizations/pin-on-image';
import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';

interface CorrectArea {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

interface PinOnImageVisualizationProps {
  imageUrl: string | undefined;
  imageSize: { width: number; height: number };
  results: PinOnImageResult[];
  disableAnimations: boolean;
  correctArea:
    | { type: 'disabled' }
    | { type: 'enabled-hidden'; correctArea: CorrectArea }
    | { type: 'enabled-visible'; correctArea: CorrectArea };
}

export const PinOnImageVisualization = ({
  imageUrl,
  imageSize,
  results,
  disableAnimations,
  correctArea,
}: PinOnImageVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      fonts: { body },
      colors: { neutral },
    },
  } = useRagnar();

  const pinColor = fillColors.length > 0 ? fillColors[0]! : textColor;

  const data = results.map((result) => ({
    id: result.x.toString() + result.y.toString(),
    numberOfPins: result.responseCount,
    position: {
      percentageX: result.x,
      percentageY: result.y,
    },
  }));

  return (
    <Box
      width="100%"
      height="100%"
      px="4%"
      alignItems="center"
      justifyContent="center"
    >
      <PinOnImage
        width={imageSize.width}
        height={imageSize.height}
        pinColor={pinColor}
        data={data}
        disableAnimations={disableAnimations}
        fontFamily={body}
        image={
          imageUrl ? { url: imageUrl } : { placeholderImageColor: neutral }
        }
        correctArea={correctArea}
      />
    </Box>
  );
};
